import { useNavigate, useLocation } from 'react-router-dom'
import { useCallback } from 'react'

export const useNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const moveToPageByPath = useCallback(
    (path: string) => {
      switch (path) {
        case 'sign-in':
          navigate('/sign-in')
          break
        case 'sign-up':
          navigate('/sign-up')
          break
        case 'video-editor':
          navigate('/video-editor')
          break
        case 'short-video-editor?createType=link':
          navigate('/short-video-editor?createType=link')
          break
        case 'short-video-editor?createType=text':
          navigate('/short-video-editor?createType=text')
          break
        case 'ai-studio':
          navigate('/ai-studio')
          break
        case 'ai-studio/video/ai-video':
          navigate('/ai-studio/video/ai-video')
          break
        case 'ai-studio/video/lip-sync':
          navigate('/ai-studio/video/lip-sync')
          break
        case 'ai-studio/video/ugc':
          navigate('/ai-studio/video/ugc')
          break
        case 'ai-studio/image/product-character':
          navigate('/ai-studio/image/product-character')
          break
        case 'ai-studio/image/background':
          navigate('/ai-studio/image/background')
          break
        case 'ai-studio/image/style':
          navigate('/ai-studio/image/style')
          break
        case 'youtube-auth':
          navigate('/youtube-auth')
          break
        case 'my-payments':
          navigate('/my-payments')
          break
        case 'my-videos':
          navigate('/my-videos')
          break
        case 'my-videos?type=plv':
          navigate('my-videos?type=plv')
          break
        case 'my-videos?type=psv':
          navigate('my-videos?type=psv')
          break
        case 'my-videos?type=lcv':
          navigate('/my-videos?type=lcv')
          break
        case 'price-guide':
          navigate('/price-guide')
          break
        case 'shortform-price-guide':
          navigate('/shortform-price-guide')
          break
        case 'faq':
          navigate('/QnA')
          break
        case 'my-cash-dashboard':
          navigate('/my-cash-dashboard')
          break
        case 'event-page':
          navigate('/event-page')
          break
        case 'my-page':
          navigate('/my-page')
          break
        case 'challenge':
          navigate('/challenge')
          break
        case 'coupon-pck':
          navigate('/coupon-pack')
          break
        case 'gallery':
          navigate('ai-studio/gallery')
          break
        case 'global':
          // 외부 링크
          window.open('https://fastcut.ai', '_blank', 'noopener,noreferrer')
          break
        case 'blog':
          // 외부 링크
          window.open(
            'https://blog.fastseller.shop/',
            '_blank',
            'noopener,noreferrer',
          )
          break
        case 'styleRoom-price-guide':
          navigate('price/style-room?selectType=fashion')
          break
        case 'create/image':
          navigate('/ai/create/image')
          break
        case 'create/video':
          navigate('/ai/create/video')
          break
        default:
          navigate('/')
          break
      }
    },
    [navigate],
  )

  const isCurrentPath = useCallback(
    (path: string) => {
      if (path === 'home' || path === '') {
        return location.pathname === '/'
      }
      return location.pathname.includes(path)
    },
    [location.pathname],
  )

  const getCurrentPath = useCallback(() => {
    return location.pathname
  }, [location.pathname])

  return {
    moveToPageByPath,
    isCurrentPath,
    getCurrentPath,
    location,
  }
}
